import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Routes from './routes';

const getTitleFromPath = (path, complement) => {
    let routes = Routes.subroutes;
    let nomRoute = '';

    const pathSplit = path.split('/');
    pathSplit.forEach((partiePath) => {
        const routeTrouve = Object.values(routes).find(
            (route) => route.route.split('/')[1] === partiePath,
        );
        if (routeTrouve && routeTrouve.subroutes) {
            routes = routeTrouve.subroutes;
            nomRoute = routeTrouve.nom;
        }
    });

    if (complement) {
        nomRoute = `${nomRoute} - ${complement}`;
    }

    return nomRoute ? `${nomRoute} - SIA Espace Détenteurs` : 'SIA Espace Détenteurs';
};

const DynamicTitle = () => {
    const location = useLocation();
    const complement = useSelector((state) => state.titre.complement);

    useEffect(() => {
        document.title = getTitleFromPath(location.pathname, complement);
    }, [location, complement]);

    return null;
};

export default DynamicTitle;
